import {
	Breakpoints,
	Container,
	ContainerGutter,
	ReferenceBadge,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import { huchaLinesColor } from '../../../../../../../../helpers/color-tokens';
import { Super200SymbolText, Super200Text } from '../../../ui/money-font-styles';

const StyledC3Wrapper = styled.div`
	border: 2px solid ${huchaLinesColor};
	border-radius: 16px;
	align-content: center;
	padding-left: var(--size-dynamic0130);
	padding-right: var(--size-dynamic0130);
	height: 160px;
`;

const StyledReferenceBadge = styled(ReferenceBadge)`
	margin-top: 20px;
`;

export const PdfHuchaStandardCardC3: React.FC<{
	dineroHucha: string;
}> = ({ dineroHucha }) => {
	const badge = '1';

	return (
		<Container stretchContent data-testid="pdf-c3-container">
			<StyledC3Wrapper>
				<Container
					gutter={ContainerGutter.static450}
					verticalAlign="center"
					stretchContent
					horizontalAlign="center"
					data-testid="pdf-c3-inner-container"
					wrap={{ [Breakpoints.default]: 'always', [Breakpoints.b960]: 'never' }}
				>
					<Container wrap="always" verticalAlign="center" horizontalAlign="center">
						<Text
							appearance={TokenTextAppearance.headline200}
							color={TokenTextColor.inverted}
							textAlign={TextAlignment.center}
							bold
						>
							{'Llevas acumulado'}
						</Text>
						<Container wrap="never" horizontalAlign="center">
							<Container wrap="never" verticalAlign="flex-end">
								<Super200Text color={TokenTextColor.inverted}>{dineroHucha}</Super200Text>
								<Super200SymbolText color={TokenTextColor.inverted}>{'€'}</Super200SymbolText>
							</Container>

							<StyledReferenceBadge variant="large">{badge.replace(/\.$/, '')}</StyledReferenceBadge>
						</Container>
					</Container>
				</Container>
			</StyledC3Wrapper>
		</Container>
	);
};
